export const css = {
    root: '_20Wwt6uE',
    question: '_17nx8mNV',
    feedback: '_3ItXUewP',
    rationale: '_3IPL52Dz',
    fmi: '_1V__nnEJ',
    distractorBlock: '_3SpiDWrB',
    distractorFieldset: 'cOfQlZKi',
    distractorLegend: '_1-F0OMBi',
    distractor: '_2sKTqOhU',
    distractorLabel: '_3Ts_QPvd',
    distractorWithFlag: 'eWWjxKE9',
    distractorHint: '_1qZq0M47',
    actions: '_2ZrJxSd_',
    oneaction: '_2y30tMdx',
    markblock: '_1JL_sebw',
    timerblock: '_2leEuinD',
    timer: '_3v1gVpHA',
    ' _key': 'apic-theme/apic/quiz-widgets/mcquestion'
};
export default css;
